/**
 * @todo add support for reCaptcha v3
 * https://developers.google.com/recaptcha/docs/v3
 */
(function($) {
  'use strict';

  var forms = {
    dom: function() {
      this.$infieldLabels = $('[data-infield-label]');
      this.$datePicker = $('[data-js-hook="pickadate"]');
      this.$checkbox = $('input[data-checkbox][type="checkbox"]');
      this.$clearInput = $('[data-input-clear]');

      this.file = {
        $toggle: $('[data-toggle="file"]'),
        $preview: $('[data-file="preview"]')
      };
    },

    settings: {
      activeFile: null
    },

    checkbox: function() {
      jutil.bindCheckboxes();
    },

    clearInputs: function() {
      this.$clearInput.click(function(event) {
        event.preventDefault();
        var input = $(this).data('input-clear');
        $('#' + input).val('').trigger('keyup').blur();
      });
    },

    fileTrigger: function() {
      this.file.$toggle.click(function(event) {
        event.preventDefault();
        var $target = $($(this).data('target'));
        if ($target.length) {
          $target.trigger('click');
          forms.settings.activeFile = $target;
          forms.filePreview(true);
        }
      });
    },

    filePreview: function($bAfterTrigger) {
      if ($bAfterTrigger) {
        forms.settings.activeFile.change(function() {
          var id = forms.settings.activeFile.attr('id');
          var filename = $(this).val().split(/(\\|\/)/g).pop();
          forms.file.$preview.filter('[data-target="#' + id + '"]').html(filename).slideDown(100);
        });
      }
      else {
        $('input[type="file"]').each(function(index, element) {
          var $this = $(element);
          if ($this.val()) {
            var id = $this.attr('id');
            var filename = $this.val().split(/(\\|\/)/g).pop();
            forms.file.$preview.filter('[data-target="#' + id + '"]').html(filename).slideDown(100);
          }
        });
      }
    },

    infieldLabels: function() {
      jutil.bindInfieldLabels();
    },

    pickadate: function() {
      jutil.bindDatepickers();
    },

    forms: function() {
      jutil.bindForms();
    },

    ready: function() {
      this.dom();
      this.checkbox();
      this.clearInputs();
      this.fileTrigger();
      this.filePreview();
      this.infieldLabels();
      this.pickadate();
      this.forms();
    }
  };

  $(function() { forms.ready(); });

})(jQuery);
